import { render, staticRenderFns } from "./CreateEditAnnouncementsModal.vue?vue&type=template&id=154c4f61&"
import script from "./CreateEditAnnouncementsModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditAnnouncementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports